export default __webpack_public_path__ + "static/media/experian-logo.d75ecd50.svg";